import { render } from "./Painel.vue?vue&type=template&id=6821069a&scoped=true"
import script from "@/assets/js/painel.js?vue&type=script&lang=js"
export * from "@/assets/js/painel.js?vue&type=script&lang=js"

import "./Painel.vue?vue&type=style&index=0&id=6821069a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6821069a"]])

export default __exports__